import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/cascade';

const useStyles = createUseStyles({
  tabPanel: {
    position: 'relative',
    margin: `${Spacings.s16} 0`,
  },
  tabDisabled: {
    opacity: '32%',
  },
});

export default useStyles;
